import { Brand } from '@blade/std-lib'

export const TokenBannersHostTypeId = 'tradebot-tma/TokenBannersHost'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TokenBannersHostTypeId = typeof TokenBannersHostTypeId

export type TokenBannersHost = Brand.Branded<string, TokenBannersHostTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenBannersHost = Brand.nominal<TokenBannersHost>()
